type Props = {
  stage?: string;
  label?: string;
};

export function AIThinkingIndicator({ stage = 'Analyzing context', label = 'AI is thinking' }: Props) {
  return (
    <div className="flex items-center gap-3 rounded-lg border border-ai-200 bg-ai-50 px-4 py-3 dark:border-ai-800 dark:bg-ai-950" aria-busy="true" aria-label={label}>
      <div className="flex gap-1" aria-hidden="true">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="h-2 w-2 animate-pulse rounded-full bg-ai-500"
            style={{ animationDelay: `${i * 150}ms` }}
          />
        ))}
      </div>
      <div>
        <p className="text-sm font-medium text-ai-800 dark:text-ai-200">{label}</p>
        <p className="text-xs text-ai-600 dark:text-ai-400">{stage}</p>
      </div>
      <span className="sr-only" aria-live="polite">{stage}</span>
    </div>
  );
}
